import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'

import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { useMutation } from '@apollo/client'
import { MU_VTY } from 'graphql/mutations'
import styles from '../vehicleType.module.scss'

const VehicleTypeEdit = ({ open, setOpen, type, update, loading }) => {
  const [vTypIcon, setVTypIcon] = useState()
  const [vTypIconDetails, setVtypIconDtails] = useState(type.icon.altText)
  const [vTyp, setVTyp] = useState(type.vehicleType)

  const [call] = useMutation(MU_VTY)

  const onSubmit = () => {
    loading(true)
    setOpen(false)
    let variables = { id: parseInt(type.id) }
    if (vTypIcon !== undefined) {
      variables.icon = vTypIcon
    }
    if (vTypIconDetails !== type.icon.altText) {
      variables.iconDetails = vTypIconDetails
    }
    if (vTyp !== type.vehicleType) {
      variables.vehicleType = vTyp
    }
    call({ variables })
      .then(res => {
        update()
      })
      .catch(err => console.error(err))
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <Card>
        <CardContent>
          <Typography color="textSecondary" gutterBottom>
            Confirmation Dialog
          </Typography>
          <Typography variant="h5" component="h2"></Typography>
          <TextField
            autoFocus
            margin="dense"
            id="vehicle type"
            label="Vehicle Type"
            type="text"
            value={vTyp}
            onChange={e => setVTyp(e.target.value)}
            fullWidth
          />{' '}
          <Button
            autoFocus
            margin="dense"
            id="Vehicle Type Icon"
            label="Vehicle Type Icon"
            type="file"
            accept=".svg"
            variant="contained"
            component="label"
            className={styles.selectButton}
          >
            Select Vehicle type icon
            <input
              type="file"
              onChange={e => {
                setVTypIcon(e.target.files.item(0))
              }}
              accept=".svg"
            />
          </Button>
          <TextField
            autoFocus
            margin="dense"
            id="iconDetail"
            label="IconDetail"
            type="text"
            fullWidth
            value={vTypIconDetails}
            onChange={e => setVtypIconDtails(e.target.value)}
          />
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            onClick={() => onSubmit()}
            className={styles.submit}
            color="primary"
            disabled={
              vTypIconDetails === type.icon.altText &&
              (vTyp === type.vehicleType || vTyp.length <= 0) &&
              vTypIcon === undefined
            }
          >
            Submit
          </Button>
        </CardActions>
      </Card>
    </Dialog>
  )
}

export default VehicleTypeEdit
